<template>
    <div
        class="university-avatar-root"
        :class="{ normal: !small, small: small, pointer: !small }"
        v-bind:style="{ 'border-color': color() }"
    >
        <div
            class="logo-wrapper d-flex align-items-center justify-content-center"
        >
            <img
                v-if="logo()"
                class="uni-logo"
                :src="logo()"
                :alt="school().subDomain"
            />
            <BaseIcon
                v-else
                name="graduation-cap"
                :style="{ color: color() }"
            />
        </div>
        <div
            v-if="!data().isVerified && !small"
            class="avatar-badge d-flex align-items-center justify-content-center white"
        >
            <BaseIcon name="exclamation" size="xs" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'UniversityAvatar',
    props: {
        connection: {
            type: Object,
            default: () => ({}),
        },
        small: Boolean,
    },
    methods: {
        data() {
            return this.connection || {};
        },
        school() {
            return this.data().school || {};
        },
        logo() {
            return this.school().logo;
        },
        color() {
            const color = this.school().primaryColor;
            if (!this.data().isVerified) {
                return 'var(--pending)';
            }
            return color && color !== 'ffffff' ? '#' + color : 'black';
        },
    },
};
</script>

<style scoped>
.university-avatar-root {
    box-sizing: border-box;
    border-width: 3px;
    border-style: solid;
    border-radius: 50%;
    background-color: white;

    position: relative;
    cursor: pointer;
}

/* Sizes */
.small {
    width: 28px;
    height: 28px;
}
.normal {
    width: 40px;
    height: 40px;
}

.logo-wrapper {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    overflow: hidden;
}
.uni-logo {
    height: 70%;
    width: 70%;
    object-fit: scale-down;
}

.avatar-badge {
    position: absolute;
    top: -7px;
    left: -4px;

    border-radius: 50%;
    background-color: var(--error);
    width: 17px;
    height: 17px;

    font-size: 10px;
    z-index: 300;
}
</style>
